module.exports = __webpack_public_path__ + "static/media/parceria_new.e26be12c.png";